export const Server = {
  endpoint: process.env.REACT_APP_ENDPOINT,
  project: process.env.REACT_APP_PROJECT,
  eventscollectionID: process.env.REACT_APP_EVENT_COLLECTION_ID,
  artcollectionID: process.env.REACT_APP_ART_COLLECTION_ID,
  donationcollectionID: process.env.REACT_APP_DONATION_COLLECTION_ID,
  databaseID: process.env.REACT_APP_DATABASE_ID,
  bucketID: process.env.REACT_APP_STORAGE_BUCKET_ID,
  trackUserLocationFunctionID:
    process.env.REACT_APP_TRACK_USER_LOCATION_FUNCTION_ID,
};
